import React, { Component } from 'react'
import PropTypes from 'prop-types'
import humps from 'humps'
import classnames from 'classnames'
import RadialProgress from '../../../generic/RadialProgress'
import keyUpHandler from '../../../utils/keyUpHandler'

class RadialProgressCategory extends Component {
  static getCategoryIconName(category) {
    return category
      .replace('&', '')
      .replace(',', '')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  render() {
    const { filtrable, filterActive, owned, current, onClick, width, amount, radialProgressSize } = this.props
    const pctg = owned ? (current.completed / current.total) * 100 : 0
    const categoryLabel = humps.decamelize(current.category, { separator: ' ', split: /(?=[A-Z&])/ })

    return (
      <div
        className={classnames('category-progress', { filtrable, active: filterActive })}
        aria-label={filterActive
          ? 'Remove category filter'
          : `Show only ${categoryLabel} courses`
        }
        onClick={() => onClick(current.category)}
        onKeyUp={event => keyUpHandler(event, onClick, null, null, [current.category])}
        tabIndex={0}
        role="button"
      >
        <RadialProgress percentage={pctg} sqSize={width < ((amount * 100) + 200) ? radialProgressSize : 100}>
          <i className={`icon-${RadialProgressCategory.getCategoryIconName(current.category)}`} />
        </RadialProgress>
        <div className="name">{categoryLabel}</div>
        {owned ? (
          <div>{`${current.completed}/${current.total}`}</div>
        ) : (
          <div>{`${current.total} course${current.total === 1 ? '' : 's'}`}</div>
        )}
      </div>
    )
  }
}

RadialProgressCategory.propTypes = {
  filtrable: PropTypes.bool,
  filterActive: PropTypes.bool,
  owned: PropTypes.bool,
  current: PropTypes.shape({
    category: PropTypes.string.isRequired,
    completed: PropTypes.number,
    total: PropTypes.number.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  width: PropTypes.number,
  amount: PropTypes.number,
  radialProgressSize: PropTypes.number
}

RadialProgressCategory.defaultProps = {
  filtrable: false,
  filterActive: false,
  owned: false,
  width: 0,
  amount: 0,
  radialProgressSize: 100
}

export default RadialProgressCategory
